<template>
  <div class="c-product-info__multi">
    <product-info-multi-active
      v-if="showActiveSelections"
      :active-options="activeOptions"
      :active-bundle-type-product="activeBundleTypeProduct"
      :active-bundle-type-size="activeBundleTypeSize"
      :size-options="sizeOptions"
      :is-mobile="isMobile"
      :single-size="status.singleSizeValue"
      :bundle-slot-count="bundleSlotCount"
      :active-selections="activeSelections"
      :bundle-product.sync="bundleProduct"
      @update:size="$emit('update:size', $event)"
      @update:selection="handleSelection"
      @update:statusSelect="statusSelect = true"
    />
    <slot v-if="status.showAddToCart" />
    <template v-else-if="status.init">
      <div class="c-product-info__multi__init">
        <h3 class="t-heading-6 u-margin-bottom-x-small">
          <b class="u-all-caps">Start here</b>
        </h3>
        <p class="u-margin-bottom-x-small">
          Select {{ bundleSlotCount }} rings and their sizes to create bundle
        </p>
        <btn
          class="c-btn--large u-all-caps"
          type="primary-open"
          @click="startBundle"
        >
          Create your bundle &gt;
        </btn>
      </div>
    </template>
    <template v-else-if="status.select && !status.end">
      <transition
        :name="transitionName"
        appear
      >
        <div
          :class="{
            'c-product-info__container': !isMobile,
            'c-product-info__container--mini': miniBundle,
            'c-product-info__container--mobile': isMobile
          }"
        >
          <div class="c-product-info__multi__selection-header u-margin-bottom-x-small">
            <button
              type="button"
              class="c-modal__close"
              @click="closeModal"
            >
              <img
                class="c-modal_back-img"
                src="../../assets/icons/nav-back.svg"
                alt="close"
              >
            </button>
            <h3 class="t-heading-6 u-text-align-center u-all-caps">
              Select ring {{ bundleSlotIndex + 1 }} / {{ bundleSlotCount }}
            </h3>
          </div>
          <filter-bar
            v-if="isMobile && status.showFilterBar"
            :visible="true"
            :products="activeProducts"
            :modal-open="modalOpen"
            modal-align="right"
            :embed-filter="true"
            :modal-offset-top="navHeight"
            @clear="filtered = false"
            @click="toggleFilterModal"
            @close="modalOpen = false"
            @updated="filteredData = $event"
            @sortProducts="sortProducts($event)"
          />
          <product-info-mobile-drawer
            v-if="isMobile"
            :product="product"
            :price="price"
            :is-gift-card="isGiftCard"
            :active-bundle-type-product="activeBundleTypeProduct"
            :active-bundle-type-size="activeBundleTypeSize"
            :products="products"
            :active-options="activeOptions"
            :filtered="true"
            :is-mobile="isMobile"
            :active-selections="activeSelections"
            :irregular-prices="irregularPrices"
            :single-size="status.singleSizeValue"
            :size-options="sizeOptions"
            :bundle-slot-count="bundleSlotCount"
            :bundle-product.sync="bundleProduct"
            :grid-cols="gridCols"
            :mini-bundle="miniBundle"
            @close="closeModal"
            @update:size="$emit('update:size', $event)"
            @update:selection="handleSelection"
            @engraving="$emit('engraving', $event)"
          />
          <product-info-modal
            v-else
            class="c-product-modal-screen"
            :modal-open="status.productInfoModalOpen"
            :full-screen="true"
            :mini-bundle="miniBundle"
            align="right"
          >
            <product-info-drawer
              :product="product"
              :is-gift-card="isGiftCard"
              :active-bundle-type-product="activeBundleTypeProduct"
              :active-bundle-type-size="activeBundleTypeSize"
              :products="products"
              :active-options="activeOptions"
              :filtered="true"
              :is-mobile="isMobile"
              :active-selections="activeSelections"
              :irregular-prices="irregularPrices"
              :single-size="status.singleSizeValue"
              :size-options="sizeOptions"
              :bundle-slot-count="bundleSlotCount"
              :bundle-product.sync="bundleProduct"
              :grid-cols="gridCols"
              :mini-bundle="miniBundle"
              @update:selection="handleSelection"
              @close="closeModal"
              @update:size="$emit('update:size', $event)"
              @modal:open="$emit('modal:open')"
              @engraving="$emit('engraving', $event)"
            >
              <template #filterBar>
                <filter-bar
                  v-if="status.showFilterBar && !disableFilterBar"
                  :visible="true"
                  :products="activeProducts"
                  :modal-open="modalOpen"
                  :embed-filter="true"
                  :modal-offset-top="navHeight"
                  modal-align="right"
                  @clear="filtered = false"
                  @click="toggleFilterModal"
                  @close="modalOpen = false"
                  @updated="filteredData = $event"
                  @sortProducts="sortProducts($event)"
                />
              </template>
              <template #close>
                <button
                  v-if="status.bundleCardOpen"
                  type="button"
                  class="c-modal__close c-close__button"
                  @click="closeModal"
                >
                  <img
                    src="../../assets/icons/nav-close--black.svg"
                    alt="close"
                  >
                </button>
              </template>
            </product-info-drawer>
          </product-info-modal>
        </div>
      </transition>
    </template>
  </div>
</template>
<script>
import Btn from '../button/Btn'
import FilterBar from '~/components/FilterBar'
import get from 'lodash/get'
import ProductInfoMultiActive from './ProductInfoMultiActive'
import StockDataMixin from './StockDataMixin'
import FiltersMixin from './FiltersMixin'
import { mapActions } from 'vuex'

const initData = (isMobile = false) => {
  return {
    statusInit: true,
    statusSelect: true,
    statusEnd: false,
    breakPoint: 1200,
    winWidth: 0,
    isMobile,
    modalOpen: false,
    filtered: false,
    filteredData: null,
    bundleProduct: null,
    navHeight: null
  }
}

export default {
  components: {
    Btn,
    FilterBar,
    ProductInfoMobileDrawer: () => import(
      /* webpackPrefetch: true */
      './ProductInfoMobileDrawer'
    ),
    ProductInfoDrawer: () => import(
      /* webpackPrefetch: true */
      './ProductInfoDrawer'
    ),
    ProductInfoModal: () => import(
      /* webpackPrefetch: true */
      './ProductInfoModal'
    ),
    ProductInfoMultiActive
  },
  mixins: [
    StockDataMixin,
    FiltersMixin,
  ],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    activeBundleTypeProduct: {
      type: Object,
      default: () => ({})
    },
    activeBundleTypeSize: {
      type: Object,
      default: () => ({})
    },
    bundleTypeProducts: {
      type: Object,
      default: () => ({})
    },
    bundleSingleSize: {
      type: Boolean,
      default: false
    },
    isBundle: {
      type: Boolean,
      default: false
    },
    isGiftCard: {
      type: Boolean,
      default: false
    },
    variantInStock: {
      type: Object,
      default: () => ({})
    },
    stockStatus: {
      type: Object,
      default: () => ({})
    },
    miniBundle: {
      type: Boolean,
      default: false
    },
    disableFilterBar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return initData()
  },
  computed: {
    transitionName() {
      const miniBundle = this.miniBundle
      let n = 'fade'
      if (miniBundle) {
        n = 'fast'
      }
      return n
    },
    /**
     * compute valid status flags
     */
    status() {
      const statusInit = this.statusInit
      const bundleProduct = this.bundleProduct
      const bundleSingleSize = this.bundleSingleSize
      const bundleSingleSizeValue = this.bundleSingleSizeValue
      const statusSelect = this.statusSelect
      const statusEnd = this.statusEnd
      const bundleSlotCount = this.bundleSlotCount
      const activeSelections = this.activeSelections
      const activeSelectionsCount = (activeSelections)
        ? activeSelections.length
        : -1
      // compound status flags
      const select = !statusInit && statusSelect
      const showAddToCart = (
        !statusInit &&
        (bundleSlotCount === activeSelectionsCount)
      )
      const productInfoModalOpen = select && !statusEnd
      const singleSizeValue = bundleSingleSize ? bundleSingleSizeValue : null
      const showFilterBar = !bundleProduct
      // status object
      return {
        end: statusEnd,
        init: statusInit,
        productInfoModalOpen,
        select,
        showAddToCart,
        singleSize: bundleSingleSize,
        singleSizeValue,
        showFilterBar
      }
    },
    gridCols() {
      const winWidth = this.winWidth
      return (winWidth >= 1400) ? 3 : 2
    },
    /**
     *
    **/
    showActiveSelections() {
      const status = this.status
      const isMobile = this.isMobile
      const activeSelections = this.activeSelections
      const hasActiveSelections = (Object.keys(activeSelections || {}).length > 0)
      return (
        (isMobile && !status.init) ||
        (isMobile && status.select) ||
        (hasActiveSelections)
      )
    },
    /**
     * track selected products by slot
     */
    activeSelections() {
      const activeSlots = this.activeBundleTypeProduct
      const variantInStock = this.variantInStock
      let selections = []
      for (let [ bundleType, product ] of Object.entries(activeSlots)) {
        if (product && product.variant) {
          selections.push({
            bundleType,
            product,
            sizes: this.productStockOptions(product, variantInStock[bundleType])
          })
        }
      }
      return selections
    },
    // used to render the option list
    activeOptions() {
      const bundleTypeProducts = this.bundleTypeProducts
      const bundleSlotIndex = this.bundleSlotIndex
      const variantInStock = this.variantInStock
      let options = []
      for (let [ bundleType, products ] of Object.entries(bundleTypeProducts)) {
        let slot = []
        for (let product of products) {
          slot.push({
            bundleType,
            product,
            sizes: this.productStockOptions(product, variantInStock[bundleType])
          })
        }
        options.push(slot)
      }
      return options[bundleSlotIndex] || []
    },
    /**
     * tracks the current bundle slot
     */
    bundleSlotIndex() {
      const activeSlots = this.activeBundleTypeProduct
      const bundleProduct = this.bundleProduct
      let selections = []
      for (let [ bundleType, product ] of Object.entries(activeSlots)) {
        if (product && product.variant) {
          const selectionId = `${bundleType}-${product.handle}+variants`
          if (bundleProduct && (product.id === bundleProduct.id)) {
            selections.push(null)
          } else {
            selections.push(selectionId)
          }
        } else {
          selections.push(null)
        }
      }
      return selections.indexOf(null)
    },
    /**
     * bundles selections are organized into "slots" that restrict the available
     * selections by position in the bundle.
     */
    bundleSlotCount() {
      const activeBundleTypeProduct = this.activeBundleTypeProduct
      return Object.keys(activeBundleTypeProduct || {}).length
    },
    irregularPrices(){
      const bundleComparePrices = this.activeOptions.map(
        e => +e.product.variants[0].compareAtPrice) || null
      const bundleVariantPrices = this.activeOptions.map(
        e => +e.product.variants[0].price) || null
      const allEqualCompare = bundleComparePrices.every(
        val => val === bundleComparePrices[0]) || null
      const allEqualVariant = bundleVariantPrices.every(
        val => val === bundleVariantPrices[0]) || null
      let result = !allEqualCompare || !allEqualVariant;
      return result;
    },
    price() {
      const product = this.product;
      let result = get(product, 'variants[0].price')
      if (!result && (process.env.NODE_ENV === 'debug')) {
        console.warn('[Product Card]: Invalid or missing current price!')
      }

      result = String((+result / this.bundleSlotCount).toFixed(2))

      //FIXME This should not be needed. price is not coming correctly.
      if(result.includes(".0") && !result.includes(".00"))
        result -= '.0';
      return result
    },
    bundleSingleSizeValue() {
      const bundleSingleSizeOptions = this.bundleSingleSizeOptions
      return this.activeBundleTypeSize[bundleSingleSizeOptions.$bundleType]
    },
    /**
     * compute size options from available bundle products
     */
    bundleTypeSizeOptions() {
      const variantInStock = this.variantInStock
      const bundleTypeProducts = this.bundleTypeProducts
      let index = {}
      for (let [bundleType, products] of Object.entries(bundleTypeProducts)) {
        // only the first product?
        const product = get(products, '[0]', null)
        index[bundleType] = this.productStockOptions(
          product,
          variantInStock[bundleType]
        )
      }
      return index
    },
    /**
     * size options, constrained to the size options that are available on ALL
     * slots.
     */
    bundleSingleSizeOptions() {
      const bundleTypeSizeOptions = this.bundleTypeSizeOptions
      const types = Object.keys(bundleTypeSizeOptions)
      let result = {
        get $bundleType() {
          return types[0]
        },
        get $initOptions() {
          return this[this.$bundleType] || []
        }
      }
      let options = {}
      for (let items of Object.values(bundleTypeSizeOptions)) {
        for (let { value } of items) {
          if (!options[value]) {
            options[value] = 0
          }
          options[value] += 1
        }
      }
      for (let key of types) {
        const items = bundleTypeSizeOptions[key]
        result[key] = []
        for (let item of items) {
          if (item && (options[item.value] === types.length)) {
            result[key].push({ ...item })
          }
        }
      }
      return result
    },
    sizeOptions() {
      const bundleSingleSize = this.bundleSingleSize
      const bundleTypeSizeOptions = this.bundleTypeSizeOptions
      const bundleSingleSizeOptions = this.bundleSingleSizeOptions
      return (bundleSingleSize)
        ? bundleSingleSizeOptions
        : bundleTypeSizeOptions
    },
    activeProducts() {
      const activeOptions = this.activeOptions
      let result = []
      for (let { bundleType, product } of activeOptions) {
        result.push({ ...product, bundleType })
      }
      return result
    },
    products() {
      const filteredData = this.filteredData
      const filtered = this.filtered
      const activeProducts = this.activeProducts
      return (filtered) ? filteredData : activeProducts
    },
  },
  watch: {
    /**
     * advance init status once the bundle size is known
     */
    bundleSingleSizeValue(value) {
      const statusInit = this.statusInit
      if (value && statusInit) {
        this.statusInit = false
      }
      this.syncSingleSize()
    },
    /**
     * track the bundle index to set valid status flags
     */
    bundleSlotIndex() {
      const isMobile = this.isMobile
      const bundleSlotCount = this.bundleSlotCount
      const bundleSlotIndex = this.bundleSlotIndex
      const haveAllSelections = bundleSlotIndex === -1
      if (haveAllSelections || isMobile) {
        this.statusSelect = false
      } else if (bundleSlotIndex < bundleSlotCount) {
        this.statusSelect = true
      }
      this.syncSingleSize()
    },
    winWidth(value) {
      if (value > 0) {
        this.isMobile = value <= this.breakPoint
      }
    },
    filteredData(value) {
      if (value) {
        this.filtered = true
      }
    },
    status({ productInfoModalOpen }) {
      if (!this.miniBundle) {
        this.dynamicBundleVisible(productInfoModalOpen)
      }
    },
    '$data': {
      handler({ statusSelect, bundleProduct }) {
        if (bundleProduct && !statusSelect) {
          this.statusSelect = true
        }
        //console.log('CLICK', bundleProduct, this.bundleSingleSizeValue)
        if (
          this.bundleSingleSize &&
          bundleProduct &&
          this.bundleSingleSizeValue
        ) {
          this.handleSelection({
            bundleType: bundleProduct.bundleType,
            event: this.bundleSingleSizeValue,
            product: bundleProduct,
          })
          this.syncSingleSize()
          this.$nextTick(() => {
            this.bundleProduct = null
          })
        }
      },
      deep: true
    }
  },
  created() {
    this.$root.$refs.productInfoMulti = this
  },
  async mounted() {
    await this.$nextTick()
    this.getWindowWidth()
    window.addEventListener("resize", this.getWindowWidth)
    await this.$nextTick()
    // console.log({ mini: this.miniBundle, isMobile: this.isMobile })
    if (this.miniBundle && !this.isMobile) {
      this.startBundle()
    }
  },
  beforeDestroy() {
    if (!this.miniBundle) {
      this.dynamicBundleVisible(false)
    }
    window.removeEventListener("resize", this.getWindowWidth);
  },
  methods: {
    ...mapActions('modal', ['dynamicBundleVisible']),
    getWindowWidth() {
      if (process.client) {
        this.winWidth = document.documentElement.clientWidth
        try {
          const el = document.getElementsByClassName('j-global-header-height')[0]
          this.navHeight = el.clientHeight
        } catch (err) {
          // this is fine
        }
      }
    },
    /**
     * update all size selections to match the input
     */
    syncSingleSize() {
      const bundleSingleSize = this.bundleSingleSize
      const bundleSlotCount = this.bundleSlotCount
      const activeSelectionsCount = this.activeSelections.length
      const bundleSingleSizeValue = this.bundleSingleSizeValue
      if (
        bundleSingleSize &&
        bundleSingleSizeValue &&
        (bundleSlotCount === activeSelectionsCount)
      ) {
        console.log('sync-single-size', {
          bundleSlotCount,
          activeSelectionsCount,
          bundleSingleSizeValue
        })
        for (let bundleType of Object.keys(this.bundleTypeProducts)) {
          this.handleSelection({ bundleType, event: bundleSingleSizeValue })
        }
      }
    },
    /**
     * update selections from a button click (used for singleSize option)
     */
    async handleSelectButton(bundleType, product) {
      // console.log('handleSelectButton', bundleType, product)
      await this.handleSelection({
        bundleType,
        event: this.bundleSingleSizeValue,
        product
      })
    },
    /**
     * emit selection events for a slot selection
     */
    async handleSelection({ bundleType, event, product }, engravingState) {
      if (product) {
        this.$emit('update:product', {
          bundleType,
          type: 'handle',
          event: product.handle
        })
        await this.$nextTick()
      }
      this.$emit('update:size', { bundleType, type: 'size', event }, engravingState)
    },
    toggleFilterModal() {
      this.filtered = true
      this.modalOpen = !this.modalOpen
    },
    handleRemove(bundleType) {
      this.$emit('update:size', { bundleType, type: 'size', event: null })
    },
    closeModal() {
      for (let [ k, v ] of Object.entries(initData(this.isMobile))) {
        this[k] = v
      }
      this.$emit('resetBundle')
    },
    sortProducts(val) {
      this.filtered = true
      this.sortBy = val
      this.sorted = true
    },
    close() {
      this.statusSelect = false
      this.statusEnd = false
    },
    startBundle() {
      this.statusInit = false;
    }
  },
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fast-enter-active,
.fast-leave-active {
  transition: opacity 0s;
}
.fast-enter,
.fast-leave-to {
  opacity: 0;
}

.c-product-info {
  &__container--mini {
    height: 100%;
  }
  &__container--mobile {
    position: fixed;
    padding-top: rem(10px);
    top: 0;
    left: 0;
    height: 100vh;
    height: -webkit-fill-available;
    width: 100vw;
    background-color: white;
    z-index: 10;
    overflow-y: scroll;
  }
  &__grid {
    padding: 0 rem(10px);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: rem(15px);
  }
  &__multi__selection-header {
    display: flex;
    align-items: center;
    justify-content: center;
    h3 {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .c-modal__close {
    appearance: none;
    background: none;
    border: 0;
    height: rem(35px);
    width: rem(35px);
    font-size: rem(36px);
    line-height: rem(44px);
    padding: rem(8px);
    text-align: center;
    cursor: pointer;

    img {
      display: block;
      height: rem(20px);
    }
  }
}

.c-close__button {
  left: 1rem;
  right: 0;
  cursor: pointer;
}
.u-all-caps {
  text-transform: uppercase;
}
.c-product-info__multi {
  @include themify($themes) {
    border-top: $border themed("foreground", "section-border");
  }
  &__init {
    text-align: center;
    margin-top: rem(10px);
  }
  &__inactive {
    text-align: center;
  }
  &__add-button {
    width: 100%;
    margin: rem(20px) 0;
  }
}
</style>
